import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=649bb797"
import script from "./SelectBox.vue?vue&type=script&lang=js"
export * from "./SelectBox.vue?vue&type=script&lang=js"
import style0 from "./SelectBox.vue?vue&type=style&index=0&id=649bb797&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports